import { useFormContext } from 'react-hook-form';

import AdvanceSettings from '../AdvanceSettings';
import DeveloperSettings from '../DeveloperSettings';
import SalesChannelDetailsForm from '../Forms/SalesChannelDetailsForm';

const MagentoForm = () => {
	const {
		formState: { isSubmitting, isLoading: isFormLoading }
	} = useFormContext();

	const isLoading = isFormLoading || isSubmitting;

	return (
		<>
			<SalesChannelDetailsForm isLoading={isLoading} showCredentials={false} showSecret={false} />
			<AdvanceSettings
				fields={['addHour', 'statuses', 'codString', 'ignoreNonCodOnPending']}
				isLoading={isLoading}
			/>

			<DeveloperSettings
				fields={[
					'secret',
					'username',
					'password',
					'productUrl',
					'ignoreRecentOrders',
					'excludePaymentMethods',
					'paymentNeedConfirm',
					'fullyPaid',
					'commentKeys',
					'statusNeedConfirm',
					'statusOnhold',
					'cityLabel',
					'districtLabel',
					'TrackingUrlType',
					'assignToWarehouse',
					'lastUpdateDate',
					'webhookStatus',
					'productUpdateDate',
					'metadata'
				]}
			/>
		</>
	);
};

export default MagentoForm;
